import { useState, useEffect } from 'react';
import { Link } from 'react-router';

import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as yup from 'yup';

import { api, useAPIContext } from '../../../../api/context';
import Icon from '../../../../components/Icon';
import { Title } from '../../../../utils/title';
import toast from '../../../../utils/toast';
import Layout from '../Layout';
import styles from './Edit.module.scss';

const Edit = () => {

  const [ loading, setLoading ] = useState(true);
  const [ initial, setInitial ] = useState({
    first_name: '',
    last_name: '',
    gender: '',
  });

  const { token } = useAPIContext();

  useEffect(() => {

    api(token).v1.profile.query()
      .then(res => {
        if (res.status === 200) {
          setLoading(false);
          setInitial({
            first_name: res.body.data.first_name,
            last_name: res.body.data.last_name,
            gender: res.body.data.gender,
          });
        }
      })
      .catch(err => {
        setLoading(false);
        toast.show(toast.KIND.WARNING, err);
      });

  }, [token]);

  return (
    <>
      <Title value='Edit - Profile' />
      <Layout>
        <div className={styles.root}>
          <div className={styles.content}>
            <div className={styles.header}>
              <Link
                to='/profile'
                aria-label='go back'>

                <Icon name={'arrow_back'} />

              </Link>

              <h1>Edit Profile</h1>
            </div>

            <Formik
              enableReinitialize={true}
              initialValues={initial}
              validationSchema={yup.object({
                first_name: yup.string()
                  .required('Required'),
                last_name: yup.string()
                  .required('Required'),
                gender: yup.string()
                  .required('Required'),
              })}
              onSubmit={(values, actions) => {

                if (loading) {
                  return;
                }

                setLoading(true);

                api(token).v1.profile
                  .update(values)
                  .then(res => {
                    setLoading(false);

                    if (res.status === 200) {
                      toast.show(toast.KIND.SUCCESS, 'Profile details saved.');
                    }

                    if (res.status === 400) {
                      toast.show(toast.KIND.ERROR, res.body);
                    }
                  })
                  .catch(err => {
                    setLoading(false);
                    toast.show(toast.KIND.WARNING, err);
                  });

              }} >

              <Form>
                <div>
                  <label htmlFor='first_name'>First Name</label>
                  <Field
                    id='first_name'
                    aria-label='first name'
                    name='first_name'
                    type='text'
                    disabled={loading}
                  />
                  <ErrorMessage
                    name='first_name'
                    component='div'
                  />
                </div>

                <div>
                  <label htmlFor='last_name'>Last Name</label>
                  <Field
                    id='last_name'
                    aria-label='last name'
                    name='last_name'
                    type='text'
                    disabled={loading}
                  />
                  <ErrorMessage
                    name='last_name'
                    component='div'
                  />
                </div>

                <div>
                  <label htmlFor='gender'>Gender</label>
                  <Field
                    id='gender'
                    as='select'
                    aria-label='gender'
                    name='gender'
                    disabled={loading} >

                    <option value='U'></option>
                    <option value='M'>Male</option>
                    <option value='F'>Female</option>
                    <option value='O'>Other</option>
                  </Field>
                  <ErrorMessage
                    name='gender'
                    component='div'
                  />
                </div>

                <button
                  type='submit'
                  disabled={loading}>

                  Save

                </button>
              </Form>

            </Formik>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default Edit;